import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.from-entries";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import React from 'react';
import { useLocation } from 'react-router-dom';
export default function useRouteQuery() {
  var location = useLocation();
  return React.useMemo(function () {
    return Object.fromEntries(new URLSearchParams(location.search));
  }, [location.search]);
}